import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog
} from "@material-ui/core"
import LoadingButton from "../../components/LoadingButton"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import {
  toggleMessageDialog,
  createMessage,
  sendMessage
} from "../../actions/companies"
import update from "immutability-helper"
import InputLabel from "@material-ui/core/InputLabel"
import Input from "@material-ui/core/Input"
import FormControl from "@material-ui/core/FormControl"
import moment from "moment"
import { openSnackBar } from "../../actions/snack-bar"

class MessageDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      message: {
        name: "",
        route: "",
        street_address: "",
        city: "",
        state: "",
        zip: "",
        date: "",
        description: ""
      }
    }
  }
  componentDidUpdate(p) {
    if (this.props.open && !p.open) {
      this.setDate()
    }
  }
  checkSetPosition = () => {
    if (this.props.messagePosition) {
      this.setState(
        update(this.state, {
          message: {
            position: {
              $set: this.props.messagePosition
            }
          }
        })
      )
    }
  }
  setDate = () => {
    this.setState(
      update(this.state, {
        message: {
          date: {
            $set: moment(new Date())
              .add(1, "days")
              .format("YYYY-MM-DD HH:mm:ss")
          }
        }
      })
    )
  }
  handleClose = () => {
    this.props.dispatch(toggleMessageDialog())
  }
  clearState = () => {
    this.setState({
      message: {
        name: "",
        route: "",
        street_address: "",
        city: "",
        state: "",
        zip: "",
        date: ""
      }
    })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    let newState = update(this.state, {
      message: {
        [fieldName]: { $set: value }
      }
    })
    this.setState(newState)
  }
  handleDateChange = data => {
    const date = data.format("YYYY-MM-DD HH:mm:ss")
    this.setState(
      update(this.state, {
        message: {
          date: {
            $set: date
          }
        }
      })
    )
  }
  onAddressChange = place => {
    let updates = {}
    for (const key in place) {
      updates[key] = {
        $set: place[key] || ""
      }
    }
    this.setState(
      update(this.state, {
        message: {
          ...updates
        }
      })
    )
  }
  submit = e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({ savingMessage: true })
    this.props
      .dispatch(createMessage(this.state.message, this.props.messageUser.id))
      .then(res => {
        this.props
          .dispatch(sendMessage(res.id))
          .then(res2 => {
            this.setState({ savingMessage: false })
            this.props.dispatch(
              openSnackBar({
                message: "Message request was sent"
              })
            )
            this.handleClose()
          })
          .catch(err => {
            console.log(err)
            this.setState({ savingMessage: false })
            this.props.dispatch(
              openSnackBar({
                message: "There was an error sending this message"
              })
            )
          })
      })
      .catch(err => {
        console.log(err)
        this.setState({ savingMessage: false })
        this.props.dispatch(
          openSnackBar({
            message: "There was an error creating this message"
          })
        )
      })
  }
  render() {
    const { fullScreen, classes, messageUser } = this.props
    const { message } = this.state
    return (
      <Fragment>
        <Dialog
          className={classes.messageDialog}
          fullScreen={fullScreen}
          open={this.props.open}
          onEntering={this.checkSetPosition}
          onClose={this.handleClose}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper
            }
          }}
        >
          <form onSubmit={this.submit} autoComplete="off">
            <DialogContent className={classes.dialogContent}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Typography>
                    Crew:<b>{` ${messageUser.first_name} ${
                      messageUser.last_name
                    }`}</b>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4} className={classes.marginWrapper}>
                <Grid item xs={12}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="description">
                      Message to Crew Member
                    </InputLabel>
                    <Input
                      id="outlined-multiline-flexible"
                      type="text"
                      fullWidth
                      multiline
                      rowsMax="10"
                      name="description"
                      value={message.description}
                      onChange={this.handleInputChange}
                      //id="description"
                      autoComplete="nope"
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions
              className={classes.dialogActions}
              classes={{
                action: classes.dialogActionsAction
              }}
            >
              <Button color="primary" onClick={this.handleClose} type="button">
                Close
              </Button>
              <LoadingButton
                color="secondary"
                buttonclicked={() => {
                  if (
                    message.name &&
                    message.city &&
                    message.date &&
                    !this.state.savingMessage
                  ) {
                    this.submit()
                  } else {
                    this.props.dispatch(
                      openSnackBar({
                        message: "Please fill out the whole sheet"
                      })
                    )
                  }
                }}
                working={this.state.savingMessage}
                type="button"
              >
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.messageDialog.messageDialogOpen,
    messageUser: state.messageDialog.messageUser,
    messagePosition: state.messageDialog.messagePosition
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(MessageDialog)
